<template>
  <div class="blog-detail">
    <div class="container">
      <v-breadcrumb
        :show-from-path="true"
        :title="data.title"
        route="blog-detail"
        :extendData="data.collections"
      />
      <p class="blog-detail__title">{{ data.title }}</p>
      <p class="blog-detail__info">
        <span>{{ new Date(data.visible_at).format("dd.MM.yyyy") }}</span>
        <span class="blog-line">&#124;</span>
        <span>{{ data.author }}</span>
        <span class="blog-line">&#124;</span>
        <span>
          <template v-for="(collection, index) in data.collections">
            <span :key="collection.id">
              <span>{{ collection.title }}</span>
              <span v-if="index < data.collections.length - 1">, </span>
            </span>
          </template>
        </span>
      </p>
      <div class="blog-detail__content" v-html="data.content" />
    </div>
  </div>
</template>

<script>

export default {
  name: "VBlogDetail",
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/mobile.scss";
.blog-line {
  display: inline-block;
  border: none;
  margin: 0 8px;
}
.blog-detail {
  padding: 59px 0 108px;
  &__title {
    font-size: 30px;
    color: #222a40;
    line-height: 1;
  }
  &__info {
    color: #888;
    font-size: 16px;
    line-height: 1;
    margin-top: 30px;
    display: flex;
    align-items: center;
  }
  &__content {
    margin-top: 30px;
    h2 {
      font-size: 24px;
    }
  }

  @media only screen and (max-width: 767px) {
    padding: px(24) 0 px(40);
    &__title {
      font-size: px(18);
    }
    &__info {
      margin-top: px(15);
      font-size: px(12);
      i {
        height: px(12);
      }
    }
    &__content {
      margin-top: px(15);
      font-size: px(14);
    }
  }
}
</style>
